import {PricingSectionSliceReskinPrimaryFirstPackageItem, PricingSectionSlice} from 'prismicio-types'

type BackgroundColors = PricingSectionSliceReskinPrimaryFirstPackageItem['background_color']

export const getFill = (variation: PricingSectionSlice['variation'], backgroundColor: BackgroundColors) => {
  if (variation === 'reskin') {
    switch (backgroundColor) {
      case 'Moss White':
        return '#4A4A4A'
      case 'Dark Green':
        return '#B9FF3F'
      default:
        return '#FFF'
    }
  }

  return '#85B833'
}

export const getHoverClass = (backgroundColor: BackgroundColors, isLinkActive: boolean) => {
  if (!backgroundColor || !isLinkActive) {
    return ''
  }

  switch (backgroundColor) {
    case 'Moss White':
      return 'group-hover:text-moss-grey-400'
    case 'Dark Green':
      return 'group-hover:text-green-neon'
    default:
      return ''
  }
}
